import { useCallback, useId, useState } from 'react';

export function useTabPanel<T extends { id: string }>(items: readonly T[]) {
  const baseId = useId();
  const [activeId, setActiveId] = useState(items[0]?.id ?? '');
  const active = items.find((item) => item.id === activeId) ?? items[0];

  const getTabProps = useCallback(
    (item: T, selected: boolean) => ({
      id: `${baseId}-${item.id}-tab`,
      'aria-controls': `${baseId}-${item.id}-panel`,
      'aria-selected': selected,
      tabIndex: selected ? 0 : -1,
      role: 'tab' as const,
      onClick: () => setActiveId(item.id),
    }),
    [baseId]
  );

  const getPanelProps = useCallback(
    (item: T) => ({
      id: `${baseId}-${item.id}-panel`,
      'aria-labelledby': `${baseId}-${item.id}-tab`,
      role: 'tabpanel' as const,
      hidden: item.id !== activeId,
    }),
    [activeId, baseId]
  );

  return { active, activeId, baseId, getTabProps, getPanelProps, setActiveId };
}
